export default {
	getHumanDateAndTime (date) {
		if (date == null || date == '') return date;
		let arrayDate;
		if (typeof date === 'string' || typeof date === 'number') {
			arrayDate = date.split(/[^0-9]/);
			date = date.replace('Z', '');
			if (date.length == 10) date = new Date(`${date}T05:49:20.13541Z`);
			else date = new Date(date.replace(/\s/, 'T'));
		}
		let day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
		let month = (date.getMonth() + 1) < 10 ? `0${(date.getMonth() + 1)}` : (date.getMonth() + 1);
		let hours;
		if (arrayDate && arrayDate[3]) hours = arrayDate[3];
		else hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
		let minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
		let seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
		return `${day}/${month}/${date.getFullYear()} a las ${hours}:${minutes}:${seconds}`;
	},
	getHumanDate (date) {
		if (date == null || date == '') return date;
		if (typeof date === 'string' || typeof date === 'number') {
			date = date.replace('Z', '');
			if (date.length == 10) date = new Date(`${date}T05:49:20.13541Z`);
			else date = new Date(date.replace(/\s/, 'T'));
		}
		let day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
		let month = (date.getMonth() + 1) < 10 ? `0${(date.getMonth() + 1)}` : (date.getMonth() + 1);
		let hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
		let minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
		let seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
		return `${day}/${month}/${date.getFullYear()}`;
	},
	getHumanDateInverse (date) {
		if (typeof date === 'string' || typeof date === 'number') date = new Date(date);
		let day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
		let month = (date.getMonth() + 1) < 10 ? `0${(date.getMonth() + 1)}` : (date.getMonth() + 1);
		return `${date.getFullYear()}/${month}/${day}`;
	},
	getISODate (date) {
		if (typeof date === 'string') date = new Date(date);
		let month = '';
		let day = '';
		if ((date.getMonth() + 1) < 10) month = `0${(date.getMonth() + 1)}`;
		else month = (date.getMonth() + 1);
		if (date.getDate() < 10) day = `0${date.getDate()}`;
		else day = date.getDate();
		return `${date.getFullYear()}-${month}-${day}`;
	},
	getISODateAndTime (date) {
		if (typeof date === 'string') date = new Date(date);
		let month = '';
		let day = '';
		if ((date.getMonth() + 1) < 10) month = `0${(date.getMonth() + 1)}`;
		else month = (date.getMonth() + 1);
		if (date.getDate() < 10) day = `0${date.getDate()}`;
		else day = date.getDate();
		return `${date.getFullYear()}-${month}-${day}T${date.getHours()}:${date.getMinutes()}`;
	},
	getSimplifiedDate (timestamp, uppercase = true, text = true, addRemainingSmallerUnit = false) {

		let rest = Date.now() - timestamp;
		let string;

		if (rest > 0 && text) {
			string = 'Hace ';
		} else if (text) {
			string = 'Faltan ';
		} else {
			string = '';
		}

		if (!uppercase) string = string.toLowerCase();

		rest = Math.abs(rest);

		let minute = 60 * 1000;
		let hour = 60 * minute;
		let day = hour * 24;

		if (rest > day) {
			let days = Math.floor(rest / day);
			string += days + ' día';
			if (days > 1) string += 's';

			if (addRemainingSmallerUnit) {
				let remainingHours = Math.floor((rest - (day * days)) / hour);
				if (remainingHours > 0) {
					string += ' ' + remainingHours + ' hora';
					if (remainingHours > 1) string += 's';
				}
			}

		} else if (rest > hour) {
			let hours = Math.floor(rest / hour);
			string += hours + ' hora';
			if (hours > 1) string += 's';

			if (addRemainingSmallerUnit) {
				let remainingMinutes = Math.floor((rest - (hour * hours)) / minute);

				if (remainingMinutes > 0) {
					string += ' ' + remainingMinutes + ' minuto';
					if (remainingMinutes > 1) string += 's';
				}
			}

		} else if (rest > minute) {
			let minutes = Math.floor(rest / minute);
			string += minutes + ' minuto';
			if (minutes > 1) string += 's';
		} else {
			string = 'Justo ahora';
		}

		return string;
	}
};



// WEBPACK FOOTER //
// ./src/helpers/dateTime.js